import { call, put, takeEvery } from "redux-saga/effects";
import { 
    fetchDisconnectBOCOnlineFunctionsServiceRequest, 
    fetchDisconnectBOCOnlineFunctionsServiceSuccess,
    fetchDisconnectBOCOnlineFunctionsServiceFailure
 } from "./DisconnectBOCOnlineFunctionsServiceSlice";
import { _CSAGENT_API_ENDPOINTS, USER_ACTIVITY_LOGS } from "../../../constants/AppConstants";
import UserActivityLogsPayload from "../../../utils/AdminPortal/UserActivityLogsPayload";
import { _CALLPUTAPI } from "../../../api/apiHandler";

async function _DisconnectBOCOnlineFunctionsService(serialNumber, userId){
    const endpoint = _CSAGENT_API_ENDPOINTS.DISCONNECT_BOC_ONLINEFUNCTIONS_SERVICE;
    const logDetails = {
        action: USER_ACTIVITY_LOGS.DISCONNECT_BOC_ONLINEFUNCTIONS_SERVICE,
        description: `Disconnect BOC onlineFunctions service for the serial number: ${serialNumber}`
    }
    const payload = {
        "servicePortalUser": await UserActivityLogsPayload(logDetails),
        "serialNumber": serialNumber ,
        "userId": userId 
      }

    return _CALLPUTAPI(endpoint, payload)
    .then(response => {
        return response;
      })
      .catch((error) => {
        throw error;
      });
}

function* fetchDisconnectBOCOnlineFunctionsServiceSaga(action){
    try {
      const {serialNumber, userId} = action.payload;
      const response = yield call(_DisconnectBOCOnlineFunctionsService, serialNumber, userId);
        yield put(fetchDisconnectBOCOnlineFunctionsServiceSuccess(response));
      } catch (error) {
        yield put(fetchDisconnectBOCOnlineFunctionsServiceFailure(error.message));
      }
    }

export default function* watchFetchDisconnectBOCOnlineFunctionsService(){
    yield takeEvery(fetchDisconnectBOCOnlineFunctionsServiceRequest.type, fetchDisconnectBOCOnlineFunctionsServiceSaga);
}